



















































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {appendDiv, deleteCookie, mount} from "@/utilities/utilities";
import {QuestionBase} from "@/utilities/question-base";
import Form from "@/components/form.vue";
import Popup from "@/components/popup.vue";
import Cta from "@/components/cta.vue";
import ErrorComp from "@/components/error.vue";
import ThankYou from "@/components/thank-you.vue";
import Loader from "@/components/loader.vue";
import {State} from "vuex-class";

@Component({
    components: {Loader, Cta, Popup, Cart: () => import('./cart.vue'), Form}
}) export default class extends Vue {
    @Prop() data;
    @State('selector') selector;
    @State('search') search;
    cart = null;
    @State('reservationId') reservationId;
    questions: any = [];
    paymentIndex = 0;
    terms = null;
    standalone = false;
    active = true;
    issuer = [];
    styleObject = {
        base: {
            background: 'white',
            padding: '0',
            color: 'black',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            fontFamily: 'Helvetica'
        },
        error: {
            color: 'red'
        },
        placeholder: {
            color: '#d8d8d8'
        },
        validated: {
            color: 'green'
        }
    };
    shouldEncrypt = false;
    paymentMethods = [];
    keys = {
        '7': 'encryptedCardNumber',
        '8': 'encryptedExpiryMonth',
        '9': 'encryptedExpiryYear',
        '10': 'encryptedSecurityCode'
    };

    async beforeMount() {

        this.$eventEmitter.subscribe('setCheckoutActive', this.setActive.bind(this));
        this.$eventEmitter.subscribe('cartUpdated', this.afterBeforeMount.bind(this));

        let script = document.createElement("script");
        script.src = "https://checkoutshopper-test.adyen.com/checkoutshopper/assets/js/sdk/checkoutSecuredFields.1.5.0.min.js";
        document.body.appendChild(script);

        this.afterBeforeMount();
    }

    @Watch('active') onActiveChange() {
        if (!this.active) {

            if(this.search) {
                let baseUrl = window.location.href.split('?')[0],
                    fullUrl = this.search['event'] ? `${baseUrl}?event=${this.search['event']}&channel=${this.search['channel']}` : baseUrl;

                history.pushState(null, document.title, fullUrl);
                this.$store.commit('set', {key: 'search', value: {event: this.search['event'], channel: this.search['channel']}});
            }
            
            document.body.style.overflow = null;

            if (!this.selector.has_Cart) {
                this.$store.dispatch('setReservationId', null);
                deleteCookie('reservationId');
            }
        } else {
            document.body.style.overflow = 'hidden';
        }
    }

    async afterBeforeMount() {
        let response = await this.$api.get('checkout', {Reservation_id: this.reservationId});

        if (response) {
            this.cart = response.Cart;

            // this.originKey = response.OriginKey;
            this.$store.dispatch('setCart', response.Cart);
            this.paymentMethods = response.PaymentMethods.map(paymentMethod => {
                if (paymentMethod.EntryFields.find(field => field.Type === 6)) {
                    paymentMethod.hasIssuer = true;
                }
                return paymentMethod;
            });


            this.terms = response.GeneralTerms;
        }
    }

    mounted() {
        document.body.style.overflow = 'hidden';


        if (this.search && this.search.resultCode && this.search.resultCode !== 'authorized') {
            this.$eventEmitter.emit('openPopup', ErrorComp, {message: 'Payment failed.'})
        }
    }


    @Watch('paymentMethods')
    async onPaymentMethodsChange() {
        this.questions = await this.getInputs();
        this.$eventEmitter.emit('setTransactionCosts', this.paymentMethods[this.paymentIndex].Method_cost);
    }

    @Watch('questions')
    onQuestionsChange() {
        if (this.shouldEncrypt) {
            this.afterAssignQuestions();
        }
    }

    @Watch('paymentIndex')
    async onPaymentIndexChange() {
        this.questions = await this.getInputs();

        this.$eventEmitter.emit('setTransactionCosts', this.paymentMethods[this.paymentIndex].Method_cost);
    }

    afterAssignQuestions() {
        window['csf']({
            configObject: {
                originKey: this.originKey
            },
            rootNode: '.checkout-form-comp',
            paymentMethods: {
                card: {
                    sfStyles: this.styleObject,
                    placeholders: {
                        encryptedCardNumber: '8171 9999 2766 0000',
                        encryptedExpiryMonth: '10',
                        encryptedExpiryYear: '30',
                        encryptedSecurityCode: '737'
                    }
                }
            }
        });
    }

    get originKey() {
        if (window.location.host.includes('localhost')) {
            return "pub.v2.8115488602560255.aHR0cDovL2xvY2FsaG9zdDo4MDgw.7VhfRzbpNbAQqrMnWJHHd9V2dHiVjLkC-3SopnKx_kQ";
        } else  {
            return "pub.v2.8115488602560255.aHR0cDovL3N0YWdpbmcuYmx1ZWJvYXQubmw.9MNBX1V8FlfQ1XvlRTGEMJi1GJVPge32hA5lgdPPShE";
        }
    }

    setActive(val)  {
        this.active = val;
    }

    async submit() {
        let issuerForm: any = this.$refs.issuerForm,
            form: any = this.$refs.form,
            values = form.submit(),
            body = {};

        if (!values) return;

        this.$eventEmitter.emit('setLoaderActive', true);

        if (issuerForm.length) {
            let issuerValues = issuerForm[0].submit();

            body['PaymentIssuer'] = issuerValues.issuer.value;
        }

        delete values.terms;

        let returnURL = this.selector.checkout_URL.length ? this.selector.checkout_URL : window.location.href,
            query = `thank-you=true&reservationId=${this.reservationId}`,
            returnURLWithQuery = returnURL + (returnURL.includes('?') ? `&${query}` : `?${query}`),
            response = await this.$api.post('createorder', Object.assign(body, {
            Reservation_id: this.reservationId,
            PaymentMethod: this.paymentMethods[this.paymentIndex].PaymentMethod_id,
            FieldEntries: Object.keys(values).map(key =>
                Object.assign({
                    name: key,
                    Field_id: this.questions.find(question => question.key === key).config.id,
                    svalue: values[key]
                })
            ),
                ReturnURL: returnURLWithQuery
        }));


        if (response) {
            if (response.PayRedirectURL && response.PayRedirectURL.length) {
                return window.open(response.PayRedirectURL, '_self')
            }

            if (response.PaymentStatus !== 10 && response.PaymentStatus !== 3) {
                return this.$eventEmitter.emit('openPopup', ErrorComp, {message: response.Error_msg});
            }


            appendDiv('thank-you');

            mount(ThankYou, '#thank-you', {
                data: {
                    Xaction_id: response.Xaction_id,
                    message: response.Customer_msg
                }
            });
        }

        this.$eventEmitter.emit('setLoaderActive', false);
    }

    setPaymentIndex(val) {
        this.paymentIndex = val;
    }

    getKey(id) {
        return this.keys[id] || id;
    }

    async getInputs() {
        this.shouldEncrypt = false;

        let issuers = this.paymentMethods[this.paymentIndex].EntryFields.filter(field => field.Type === 6),
            fields = this.paymentMethods[this.paymentIndex].EntryFields.filter(field => field.Type !== 6).map(field => {
                if (field.Type === 5) {
                    this.shouldEncrypt = true;
                }


                return new QuestionBase({
                    controlType: this.getControlType(field),
                    key: field.Name,
                    type: this.getTypeById(field.Type),
                    regex: new RegExp(field.Regex),
                    width: field.Width,
                    required: field.Required,
                    label: field.Name,
                    config: {
                        encryptedKey: this.getKey(field.Field_id),
                        id: field.Field_id,
                        type: field.Type
                    }
                })
            });

        if (issuers.length) {
            issuers = issuers.map(issuer => Object.assign({text: issuer.Name, value: issuer.Field_id}));

            this.issuer = [new QuestionBase({
                controlType: 'select',
                key: 'issuer',
                label: this.$t('selectBank'),
                options: issuers,
                value: issuers[0]
            })];
        }


        fields.push(new QuestionBase({
            key: 'terms',
            required: true,
            type: 'checkbox',
            label: this.terms
        }));

        return fields;
    }

    getTypeById(val) {
        switch(val) {
            case 7:
                return 'checkbox';
            default:
                return 'text';
        }
    }

    getInputWidth(field) {
        switch (field.Field_id) {
            case "8":
                return 40;
            case "9":
                return 40;
            case "10":
                return 20;
            default:
                return 100;
        }
    }

    getControlType(field) {
        if(field.Type === 4) return "textarea";
        if(field.Field_id === "5") return 'phone';
        if (field.Type === 5) return 'encrypted';

        return 'textbox';
    }
}
